// Generated by tools/pricegen from catalog/accelerators.yaml by `make gen`. Do not edit.
export const GPU_CATALOG = [
  {
    "id": "A10",
    "family": "A10",
    "slug": "a10-24g",
    "displayName": "NVIDIA A10 · 24 GB",
    "vendor": "NVIDIA",
    "memory": "24Gi",
    "aliases": [
      "A10-24G",
      "NVIDIA A10"
    ]
  },
  {
    "id": "A100-40G",
    "family": "A100",
    "slug": "a100-sxm-40g",
    "displayName": "NVIDIA A100 SXM · 40 GB",
    "vendor": "NVIDIA",
    "memory": "40Gi",
    "aliases": [
      "A100-SXM-40G",
      "A100-40GB",
      "A100 40GB",
      "A100-SXM4-40GB",
      "a100_40_sxm"
    ]
  },
  {
    "id": "A100-40G-PCIE",
    "family": "A100",
    "slug": "a100-pcie-40g",
    "displayName": "NVIDIA A100 PCIe · 40 GB",
    "vendor": "NVIDIA",
    "memory": "40Gi",
    "aliases": [
      "A100-PCIE-40G",
      "A100 40GB PCIe",
      "A100-PCIE-40GB",
      "a100_40_pcie"
    ]
  },
  {
    "id": "A100-80G",
    "family": "A100",
    "slug": "a100-sxm-80g",
    "displayName": "NVIDIA A100 SXM · 80 GB",
    "vendor": "NVIDIA",
    "memory": "80Gi",
    "aliases": [
      "A100-SXM-80G",
      "A100-80GB",
      "A100 80GB",
      "A100-SXM4-80GB",
      "A100 SXM4 80GB",
      "a100_80_sxm"
    ]
  },
  {
    "id": "A100-80G-PCIE",
    "family": "A100",
    "slug": "a100-pcie-80g",
    "displayName": "NVIDIA A100 PCIe · 80 GB",
    "vendor": "NVIDIA",
    "memory": "80Gi",
    "aliases": [
      "A100-PCIE-80G",
      "A100 80GB PCIe",
      "A100-PCIE-80GB",
      "a100_80_pcie"
    ]
  },
  {
    "id": "A10G",
    "family": "A10G",
    "slug": "a10g-24g",
    "displayName": "NVIDIA A10G · 24 GB",
    "vendor": "NVIDIA",
    "memory": "24Gi",
    "aliases": [
      "NVIDIA A10G"
    ]
  },
  {
    "id": "A40",
    "family": "A40",
    "slug": "a40-48g",
    "displayName": "NVIDIA A40 · 48 GB",
    "vendor": "NVIDIA",
    "memory": "48Gi",
    "aliases": [
      "NVIDIA A40"
    ]
  },
  {
    "id": "B200",
    "family": "B200",
    "slug": "b200-180g",
    "displayName": "NVIDIA B200 · 180 GB",
    "vendor": "NVIDIA",
    "memory": "180Gi",
    "aliases": [
      "B200-SXM",
      "NVIDIA B200"
    ]
  },
  {
    "id": "B300",
    "family": "B300",
    "slug": "b300-288g",
    "displayName": "NVIDIA B300 · 288 GB",
    "vendor": "NVIDIA",
    "memory": "288Gi",
    "aliases": [
      "B300-SXM",
      "NVIDIA B300",
      "NVIDIA B300 SXM6 AC"
    ]
  },
  {
    "id": "H100-NVL",
    "family": "H100",
    "slug": "h100-nvl-94g",
    "displayName": "NVIDIA H100 NVL · 94 GB",
    "vendor": "NVIDIA",
    "memory": "94Gi",
    "aliases": [
      "H100 NVL",
      "NVIDIA H100 NVL"
    ]
  },
  {
    "id": "H100-PCIE",
    "family": "H100",
    "slug": "h100-pcie-80g",
    "displayName": "NVIDIA H100 PCIe · 80 GB",
    "vendor": "NVIDIA",
    "memory": "80Gi",
    "aliases": [
      "H100-PCIE-80G",
      "H100 PCIe",
      "H100-80GB-PCIE",
      "NVIDIA H100 PCIe",
      "h100_pcie"
    ]
  },
  {
    "id": "H100-SXM",
    "family": "H100",
    "slug": "h100-sxm-80g",
    "displayName": "NVIDIA H100 SXM · 80 GB",
    "vendor": "NVIDIA",
    "memory": "80Gi",
    "aliases": [
      "H100-SXM-80G",
      "H100 SXM",
      "H100-SXM5",
      "H100 SXM5",
      "H100 80GB HBM3",
      "H100-80GB-SXM",
      "NVIDIA H100 80GB HBM3",
      "h100_sxm"
    ]
  },
  {
    "id": "H200",
    "family": "H200",
    "slug": "h200-141g",
    "displayName": "NVIDIA H200 · 141 GB",
    "vendor": "NVIDIA",
    "memory": "141Gi",
    "aliases": [
      "H200-SXM-141G",
      "H200-SXM",
      "H200 SXM",
      "NVIDIA H200",
      "H200-141GB"
    ]
  },
  {
    "id": "L4",
    "family": "L4",
    "slug": "l4-24g",
    "displayName": "NVIDIA L4 · 24 GB",
    "vendor": "NVIDIA",
    "memory": "24Gi",
    "aliases": [
      "L4-24G",
      "NVIDIA L4"
    ]
  },
  {
    "id": "L40",
    "family": "L40",
    "slug": "l40-48g",
    "displayName": "NVIDIA L40 · 48 GB",
    "vendor": "NVIDIA",
    "memory": "48Gi",
    "aliases": [
      "NVIDIA L40"
    ]
  },
  {
    "id": "L40S",
    "family": "L40S",
    "slug": "l40s-48g",
    "displayName": "NVIDIA L40S · 48 GB",
    "vendor": "NVIDIA",
    "memory": "48Gi",
    "aliases": [
      "L40S-48G",
      "NVIDIA L40S",
      "L40S-48GB"
    ]
  },
  {
    "id": "MI300X",
    "family": "MI300X",
    "slug": "mi300x-192g",
    "displayName": "AMD Instinct MI300X · 192 GB",
    "vendor": "AMD",
    "memory": "192Gi",
    "aliases": [
      "AMD Instinct MI300X",
      "MI300X-OAM"
    ]
  },
  {
    "id": "RTX-3070",
    "family": "RTX-3070",
    "slug": "rtx-3070-8g",
    "displayName": "NVIDIA RTX 3070 · 8 GB",
    "vendor": "NVIDIA",
    "memory": "8Gi",
    "aliases": [
      "3070",
      "RTX 3070",
      "GeForce RTX 3070",
      "NVIDIA GeForce RTX 3070",
      "rtx3070"
    ]
  },
  {
    "id": "RTX-3090",
    "family": "RTX-3090",
    "slug": "rtx-3090-24g",
    "displayName": "NVIDIA RTX 3090 · 24 GB",
    "vendor": "NVIDIA",
    "memory": "24Gi",
    "aliases": [
      "3090",
      "RTX 3090",
      "GeForce RTX 3090",
      "NVIDIA GeForce RTX 3090",
      "rtx3090"
    ]
  },
  {
    "id": "RTX-4000-ADA",
    "family": "RTX-4000-ADA",
    "slug": "rtx-4000-ada-20g",
    "displayName": "NVIDIA RTX 4000 Ada · 20 GB",
    "vendor": "NVIDIA",
    "memory": "20Gi",
    "aliases": [
      "RTX 4000 Ada",
      "NVIDIA RTX 4000 Ada Generation"
    ]
  },
  {
    "id": "RTX-4090",
    "family": "RTX-4090",
    "slug": "rtx-4090-24g",
    "displayName": "NVIDIA RTX 4090 · 24 GB",
    "vendor": "NVIDIA",
    "memory": "24Gi",
    "aliases": [
      "4090",
      "RTX 4090",
      "GeForce RTX 4090",
      "NVIDIA GeForce RTX 4090",
      "rtx4090"
    ]
  },
  {
    "id": "RTX-5090",
    "family": "RTX-5090",
    "slug": "rtx-5090-32g",
    "displayName": "NVIDIA RTX 5090 · 32 GB",
    "vendor": "NVIDIA",
    "memory": "32Gi",
    "aliases": [
      "5090",
      "RTX 5090",
      "GeForce RTX 5090",
      "NVIDIA GeForce RTX 5090",
      "rtx5090"
    ]
  },
  {
    "id": "RTX-6000-ADA",
    "family": "RTX-6000-ADA",
    "slug": "rtx-6000-ada-48g",
    "displayName": "NVIDIA RTX 6000 Ada · 48 GB",
    "vendor": "NVIDIA",
    "memory": "48Gi",
    "aliases": [
      "RTX 6000 Ada",
      "NVIDIA RTX 6000 Ada Generation"
    ]
  },
  {
    "id": "RTX-A4000",
    "family": "RTX-A4000",
    "slug": "rtx-a4000-16g",
    "displayName": "NVIDIA RTX A4000 · 16 GB",
    "vendor": "NVIDIA",
    "memory": "16Gi",
    "aliases": [
      "RTX A4000",
      "NVIDIA RTX A4000"
    ]
  },
  {
    "id": "RTX-A6000",
    "family": "RTX-A6000",
    "slug": "rtx-a6000-48g",
    "displayName": "NVIDIA RTX A6000 · 48 GB",
    "vendor": "NVIDIA",
    "memory": "48Gi",
    "aliases": [
      "RTXA6000-48G",
      "A6000",
      "RTX A6000",
      "NVIDIA RTX A6000",
      "rtx_a6000"
    ]
  },
  {
    "id": "RTX-PRO-6000-BLACKWELL-SERVER",
    "family": "RTX-PRO-6000",
    "slug": "rtx-pro-6000-blackwell-server-96g",
    "displayName": "NVIDIA RTX PRO 6000 Blackwell Server Edition · 96 GB",
    "vendor": "NVIDIA",
    "memory": "96Gi",
    "aliases": [
      "NVIDIA-RTX-PRO-6000-Blackwell-Server-Edition",
      "NVIDIA RTX PRO 6000 Blackwell Server Edition",
      "RTX PRO 6000 Blackwell Server Edition"
    ]
  },
  {
    "id": "T4",
    "family": "T4",
    "slug": "t4-16g",
    "displayName": "NVIDIA T4 · 16 GB",
    "vendor": "NVIDIA",
    "memory": "16Gi",
    "aliases": [
      "Tesla T4",
      "NVIDIA T4"
    ]
  }
] as const;
